<template>
  <DefaultLayout>
    <div slot="content">

      <v-dialog v-model="deleteUserConfirmationModal" width="480">
        <v-card>
          <v-card-title class="blue-grey white--text">Delete user confirmation</v-card-title>
          <v-card-text class="pt-4">
            Are you sure you want to delete user <strong>{{deleteUserEmail}}</strong>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile text color="blue" @click="deleteUserConfirmationModal = false">Cancel</v-btn>
            <v-btn tile dark depressed color="blue" @click="deleteUser">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteUserNotAllowedModal" width="480">
        <v-card>
          <v-card-title class="blue-grey white--text">You can not delete this user</v-card-title>
          <v-card-text class="pt-4">
            {{notAllowedReason}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile dark depressed color="blue" @click="deleteUserNotAllowedModal = false">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="keySecret" width="700">
        <v-card>
          <v-card-title class="blue-grey white--text">Save this key, we will not show them again.</v-card-title>
          <v-card-text class="pt-4">
            {{ keySecretText }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn tile depressed color="white" @click="toClipboard(keySecretText)">Copy key to clipboard</v-btn> -->
            <v-btn tile dark depressed color="blue" @click="keySecret = false">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>      

      <v-tabs slider-color="black" active-class="v-tabs_active_item" v-model="tabs" show-arrows>
        <v-tab class="font-weight-bold" :ripple="false">Users Management</v-tab>
        <v-tab class="font-weight-bold" :ripple="false">API keys</v-tab>
      </v-tabs>
      <v-divider></v-divider>

      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <v-row>
            <v-col sm="6" md="4">
              <div class="title">
                <strong>Delete user</strong>
              </div>
              <v-form ref="deleteUserForm">
                <v-row>
                  <v-col cols="6" sm="8" class="py-0">
                    <v-text-field v-model="deleteUserEmail" type="email" label="User email" :rules="[v => !!v || 'Please enter valid email']"></v-text-field>
                  </v-col>
                  <v-col cols="4" sm="4" class="py-0">
                    <v-btn small tile dark depressed color="blue" :loading="loading" @click="getUser" class="mt-3">Find user</v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="userData" class="align-center">
                  <v-col cols="12" sm="6" class="grey--text text--darken-4 body-2">User blocked</v-col>
                  <v-col cols="12" sm="6">
                    <v-switch class="mt-0" hide-details v-model="userData.lockoutEnabled"></v-switch>
                  </v-col>
                </v-row>
                <v-row v-if="userData" class="align-center">
                  <v-col cols="12" sm="6" class="grey--text text--darken-4 body-2">2FA App enabled</v-col>
                  <v-col cols="12" sm="6">
                    <v-switch class="mt-0" hide-details v-model="userData.twoFactorAppEnabled"></v-switch>
                  </v-col>
                </v-row>
                <v-row v-if="userData" class="align-center">
                  <v-col cols="12" sm="6" class="grey--text text--darken-4 body-2">2FA SMS enabled</v-col>
                  <v-col cols="12" sm="6">
                    <v-switch class="mt-0" hide-details v-model="userData.twoFactorEnabled"></v-switch>
                  </v-col>
                </v-row>
                <v-btn v-if="userData" small tile dark depressed color="red" :loading="loading" @click="checkDeleteUserAllowed" class="mt-3 mr-5">Delete user</v-btn>
                <v-btn v-if="userData" small tile dark depressed color="blue" :loading="loading" @click="saveUser" class="mt-3">Save</v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <div class="d-flex align-center py-4">
            <strong>Integration API keys</strong>
            <v-spacer></v-spacer>
            <v-btn id="add-user" small tile depressed color="blue white--text" :loading="loading" class="ml-4" @click="generateNewKey">Generate new key</v-btn>
          </div>
          <v-row v-for="k in apiKeys" :key="k.id">
            <v-col>
              <div>
                <strong>ID:</strong> {{ k.id }} <strong>KEY:</strong> •••••••••••••••••• <strong>ACTIVE:</strong> {{ k.active }}
              </div>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout';
import { CHECK_ALLOW_TO_REMOVE_USER, 
  REMOVE_USER, 
  GENERATE_API_KEY,
  GET_USER_DATA,
  UPDATE_USER_DATA,
  GET_API_KEYS } from '@/store/actions.type';


export default {
  name: 'users-management',
  components: {
    DefaultLayout,
  },
  data() {
    return {
      tabs: 0,
      deleteUserEmail: '',
      loading: false,
      deleteUserConfirmationModal: false,
      deleteUserNotAllowedModal: false,
      notAllowedReason: '',
      deleteUserId: '',
      loading: false,
      apiKeys: [],
      keySecret: false,
      keySecretText: '',
      userData: null
    };
  },
  methods: {
    async saveUser(){
      try {
        await this.$store.dispatch(UPDATE_USER_DATA, {
            userId: this.userData.id,
            lockoutEnabled: this.userData.lockoutEnabled,
            twoFactorEnabled: this.userData.twoFactorEnabled,
            twoFactorAppEnabled: this.userData.twoFactorAppEnabled
          });
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'User data updated!',
        });
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error',
        });
      }
    },
    async getUser(){
      this.userData = null;
      try {
        const response = await this.$store.dispatch(GET_USER_DATA, this.deleteUserEmail);
        this.userData = response;
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Not found',
        });
      }
    },
    toClipboard(text) {
        var input = document.createElement('input');
        input.setAttribute('value', text);
        document.body.appendChild(input);
        input.select();
        var result = document.execCommand('copy');
        document.body.removeChild(input);
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Copied to clipboard!',
        });
        return result;
    },
    async getApiKeys(){
      try {
        const response = await this.$store.dispatch(GET_API_KEYS);
        this.apiKeys = response;
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error getting API keys. Please contact support@planetverify.com',
        });
      }
    },
    async generateNewKey(){
      if (confirm('Generate new key?')) {
        try {
          this.loading = true;
          const response = await this.$store.dispatch(GENERATE_API_KEY, null);
          this.keySecretText = response.value.key;
          this.keySecret = true;
          this.loading = false;
          this.getApiKeys();
        } catch(err) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error generating key. Please contact support@planetverify.com',
          });
          this.loading = false;
        }
      }
    },
    async checkDeleteUserAllowed() {
      if (this.$refs.deleteUserForm.validate()) {
        try {
          const response = await this.$store.dispatch(CHECK_ALLOW_TO_REMOVE_USER, this.deleteUserEmail);
          if (response.allowToRemove) {
            this.deleteUserConfirmationModal = true;
            this.deleteUserId = response.userId;
          } else {
            this.notAllowedReason = response.reason;
            this.deleteUserNotAllowedModal = true;
          }
        } catch(err) {
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Error deleting user. Please contact support@planetverify.com',
          });
        }
      }
    },
    async deleteUser() {
      try {
        await this.$store.dispatch(REMOVE_USER, { userId: this.deleteUserId });
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'User hase been deleted',
        });
        this.deleteUserId = '';
        this.deleteUserEmail = '';
        this.deleteUserConfirmationModal = false;
      } catch(err) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error deleting user. Please contact support@planetverify.com',
        });
        this.deleteUserConfirmationModal = false;
      }
    }
  },
  mounted () {
    this.getApiKeys();
  },
}
</script>
